import { getBaseUrl } from './constants';

/**
 * Function for different debugging levels
 *
 * @param {type} - "INFO", "LOOK" , "TABLE", "ERROR"
 * @param {msg} - Message to be printed for the variable representation
 * @param {var_} - Value of the variable
 * @return {}  Debugging Mode for Any Type of variables
 */
const executeOnce = () => {
  window.executeOnceFlag = false;
  //FIXME: Only for DEVELOPMENT Purpose
  if (!window.executeOnceFlag) {
    const isProdMode = ['STAGING', 'PRODUCTION'].includes(
      process.env.REACT_APP_ENVIRONMENT
    );
    if (!isProdMode) {
      console.clear();
      console.log(
        '%c 🧪 ES Debug Mode ',
        'background: #1fdfdd; color: white; font-size: 20px; font-family: monospace'
      );
    } else {
      if (getBaseUrl() === `${window.location.origin}/`) {
        if (console && console.clear && console.log) {
          console.clear();
          console.log(
            '%c 😇 ES Production Mode ',
            'background: #5cb85c; color: white; font-size: 20px; font-family: monospace'
          );
        }
        if (console) {
          const consoleLocal = {};
          // if (window && window.console) window.console = consoleLocal;
          // console.log = function () { };
          // console.warn = function () { };
          // console.error = function () { };

          // define a new console
          const console = (function (oldCons) {
            return {
              log: function (text) {
                // oldCons.log(text);
                // Your code
              },
              info: function (text) {
                // oldCons.info(text);
                // Your code
              },
              warn: function (text) {
                // oldCons.warn(text);
                // Your code
              },
              error: function (text) {
                // oldCons.error(text);
                // Your code
              },
            };
          })(window.console);

          //Then redefine the old console
          window.console = console;
        }
      }
    }
    window.executeOnceFlag = true;
  }
};
executeOnce();
const debug = (type = 'INFO', msg = '', var_ = '', ...args) => {
  //FIXME: Only for DEVELOPMENT Purpose
  if (process.env.REACT_APP_ENVIRONMENT !== 'STAGING') {
    if (type.toLowerCase() == 'info') {
      console.log(
        `%c 🧐 INFO: `,
        'background: #5bc0de; color: white',
        msg,
        ...args
      );
    } else if (type.toLowerCase() == 'look' || type.toLowerCase() == 'watch') {
      console.log(
        `%c 👀 LOOK: `,
        'background: #5cb85c; color: white',
        `${msg} → `,
        var_,
        ...args
      );
    } else if (type.toLowerCase() == 'error') {
      console.log(
        `%c ☢️ ERROR: `,
        'background: #d9534f; color: white',
        msg,
        var_,
        ...args
      );
    } else if (type.toLowerCase() == 'table') {
      console.log(
        `%c 🏓 TABLE: `,
        'background: #f0ad4e; color: white',
        msg,
        ...args
      );
      console.table(var_);
    } else if (type.toLowerCase() == 'qa-only') {
      console.log(
        `%c 😥 INTERNAL: `,
        'background: #0000cc; color: white',
        msg,
        ...args
      );
      console.table(var_);
    } else if (type.toLowerCase() == 'request') {
      console.log(
        `%c 🔼 REQUEST: `,
        'background: #00008B; color: white',
        msg,
        var_,
        ...args
      );
    } else if (type.toLowerCase() == 'response') {
      console.log(
        `%c ✅ RESPONSE: `,
        'background: 	#006400; color: white',
        msg,
        var_,
        ...args
      );
    } else if (type.toLowerCase() == 'final return') {
      console.log(
        `%c ✅ FINAL RETURN: `,
        'background: 	#006400; color: white',
        msg,
        var_,
        ...args
      );
    }
  }
};

export default debug;
